import { BybSection, BybSectionList } from "@Components/common/byb-ds";
import BybPerformanceChip from "@Components/common/byb-ds/byb-performance-chip";
import ScrollfulContainer from "@Components/generic/scrollful-container";
import StatsList from "@Components/mobile/progress/stats-list";
import formatMetricScoreType from "@Containers/app/stat-cards/tooltips/format-metric-type";
import { useProgress } from "@Context/game/progress/progress-context";
import MetricFilterTypes from "@Enums/MetricFilterTypes";
import useI18n from "@i18n";
import { Skeleton, Stack, Typography, useTheme } from "@mui/material";
import FillingBrainIcon from "@Resources/app/icons-v2/system-icons/filling-brain-icon";

const ProgressSnapshot = () => {
  const theme = useTheme();
  const { i18n } = useI18n();
  const { currentBybIq, isCurrentBybIqLoading, snapshotStats, areSnapshotStatsLoading } = useProgress();

  if (isCurrentBybIqLoading || areSnapshotStatsLoading) {
    return (
      <ScrollfulContainer sx={{ paddingX: 0, paddingTop: theme.spacing(1) }}>
        <BybSectionList>
          <BybSection sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, paddingY: 5 }}>
            <Skeleton variant="rounded" width={200} height={220} sx={{ borderRadius: 10 }} />
            <Skeleton variant="text" width={100} height={50} />
            <Stack spacing={0.5}>
              <Skeleton variant="text" width={200} height={20} />
              <Skeleton variant="text" width={200} height={20} />
            </Stack>
            <Skeleton variant="text" width={100} height={60} />
          </BybSection>
          <StatsList stats={snapshotStats} />
        </BybSectionList>
      </ScrollfulContainer>
    );
  }

  return (
    <ScrollfulContainer sx={{ paddingX: 0, paddingTop: theme.spacing(1) }}>
      <BybSectionList>
        <BybSection sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, paddingY: 5 }}>
          <FillingBrainIcon fillPercentage={currentBybIq / 10} />
          <Typography variant="text5xl700">{formatMetricScoreType(MetricFilterTypes.BYB_IQ, currentBybIq)}</Typography>
          <Typography variant="textS500" color={theme.palette.text.secondary} textAlign="center" width={"70%"}>
            {i18n("progress.byb_iq.explanation")}
          </Typography>
          <BybPerformanceChip score={currentBybIq} />
        </BybSection>
        <StatsList stats={snapshotStats} />
      </BybSectionList>
    </ScrollfulContainer>
  );
};

export default ProgressSnapshot;
